import { Injectable } from "@angular/core";
import { CookieService } from 'ngx-cookie-service';
// import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class LandingPageService {

  // private storageEventSubject = new Subject<StorageEvent>();

  constructor(private cookieService: CookieService){
    // window.addEventListener('storage', (event) => {
    //   this.storageEventSubject.next(event);
    // });

    // this.getStorageEventObservable().subscribe((event) => {
    //   if (event.key === null) {
    //     console.log('localStorage was cleared!');
    //   }
    // });
  }

  isDismissed = (page:string) : Boolean => {
    return !!this.cookieService.get(`isLandingPageDismissed_${page}`)
  }

  dismiss(event: Event, page?: string){
    event.preventDefault()
    this.cookieService.set(`isLandingPageDismissed_${page}`, "1")
  }

  // getStorageEventObservable(): Observable<StorageEvent> {
  //   return this.storageEventSubject.asObservable();
  // }

}
